import { render, staticRenderFns } from "./Qrcode.vue?vue&type=template&id=fd21313c&scoped=true"
import script from "./Qrcode.vue?vue&type=script&lang=js"
export * from "./Qrcode.vue?vue&type=script&lang=js"
import style0 from "./Qrcode.vue?vue&type=style&index=0&id=fd21313c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd21313c",
  null
  
)

export default component.exports